module.exports = __webpack_public_path__ + "static/media/SO3.1e026df5.jpg";